import { ScrollContainer } from 'app/layout/dashboardLayout/BoxLayout';
import { DeleteDarkIcon, FileIcon } from 'assets/icons';
import Button from 'Components/Buttons/Button';
import Label from 'Components/Form/Label';

import { QuestionnaireDocument } from '.';

export function SelectedQuestionnaireDocuments({
  value: selected,
  onChange,
}: {
  value: QuestionnaireDocument[];

  onChange: (v: QuestionnaireDocument[]) => void;
}) {
  const deleteSelected = (toBeDeleted: QuestionnaireDocument) => {
    onChange(selected.filter((d) => d.id !== toBeDeleted.id));
  };

  return (
    <ScrollContainer>
      <div className="flex justify-between py-1 mr-2">
        <Label label={`${selected.length} Documents`} />
      </div>
      <ScrollContainer className="border border-gray-100 rounded-xl">
        {selected.map((document) => (
          <SelectedDocument
            key={document.id}
            value={document}
            onDelete={deleteSelected}
          />
        ))}
      </ScrollContainer>
    </ScrollContainer>
  );
}

function SelectedDocument({
  value: document,
  onDelete,
}: {
  value: QuestionnaireDocument;
  onDelete: (document: QuestionnaireDocument) => void;
}) {
  return (
    <div
      className="border-b h-10 hover:bg-gray-100/5 border-gray-100 px-2 py-0.5 cursor-default text-gray-dark items-center flex gap-2  font-semibold"
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
      }}
    >
      <FileIcon className="w-5 h-5" />
      <span className="flex-1 text-sm text-ellipsis line-clamp-1">
        {document.title}
      </span>
      <Button
        type="button"
        className="max-w-min"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onDelete(document);
        }}
      >
        <DeleteDarkIcon className="text-gray-light w-4 h-4 " />
      </Button>
    </div>
  );
}
